import { useState } from 'react'
import classes from './TextInput.module.css'

const TextInput = ({
  children,
  required,
  change,
  disabled,
  labelClasses,
  value,
  onBlurCustom,
  onFocusCustom,
  error,
  ...rest
}) => {
  const [focusClass, SetfocusClass] = useState('')

  const handleFocus = e => {
    SetfocusClass(classes.is_active)
    onFocusCustom && onFocusCustom(e)
  }

  const handleBlur = e => {
    SetfocusClass('')
    onBlurCustom && onBlurCustom(e)
  }

  return (
    <>
      <label
        className={`${classes.label}
          relative
          block
          border-1 border-solid border-white
          mx-1.5
          my-2
          px-2
          pt-2
          pb-4
          md:mx-3.5 md:my-5
          flex-grow
          font-[sans-serif]
          ${labelClasses}
        `}
      >
        <span
          className={`${classes.span}
            absolute
            text-darkGray
            top-2
            md:top-4
            left-4
            md:left-7
            text-base
            transition-transform
            ${value && value.length > 0 ? 'hidden' : ''}
            ${focusClass}
          `}
        >
          {children}
          {required && ' *'}
        </span>
        <input
          disabled={disabled}
          onChange={change}
          {...rest}
          required={required}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={`${classes.input} bg-transparent border-none w-full pt-6 px-5 pb-2`}
        />
        {error && <div className="mt-1 text-xs text-red pt-2">{error}</div>}
      </label>
    </>
  )
}

export default TextInput
